import { reduceLevel } from './reduceLevel'

export const setLevelsOnPlaceRoot = place =>
  reduceLevel({
    ...place,
    level4: place.name
  })
